/**
 *
 * The component is used mostly by the workflow logs
 *
 * @evaluation good
 * @category simple ui
 * @todo resources
 *
 */
import { Modal } from "@material-ui/core";
import KnobIcon from "@material-ui/icons/DescriptionOutlined";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import { t } from "i18next";
import React from "react";
import { useAppContext } from "./../../context/AppCtxProvider";
import useThemeClassName from "./../../themehooks/useThemeClassname";
import * as registry from "@qpr/client-api-registry";
const useStyles = makeThemedStyles("ShowRejectMessage", (theme) => ({
  Modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ModalPaper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3, 4, 3),
    height: "auto",
    minWidth: "40em",
    borderRadius: "2.97em",
    background: "#fff",
  },
  Header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  HeaderLeft: {
    display: "flex",
    alignItems: "center",
  },
  HeaderRight: {},
  Icon: {
    position: "relative",
    top: "calc(45% - 10px)",
  },
  IconContainer: {
    height: "5.48em",
    width: "5.48em",
    borderRadius: "3.65em",
    background: "rgba(0, 169, 163, 1)",
    color: "#fff",
    marginLeft: "5px",
  },
  IconClose: {
    cursor: "pointer",
    backgroundPosition: "0px 0px",
    backgroundRepeat: "no-repeat",
  },
  Title: {
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "1.11em",
    color: "rgba(17, 94, 103, 1)",
    marginLeft: "0.555em",
  },
  message: {
    fontWeight: 400,
    lineHeight: "1.25",
    color: "rgba(76, 81, 87, 1)",
    letterSpacing: "0.04px",
    fontSize: "16px",
  },
}));
const ShowRejectMessage = (props: {
  show: boolean;
  handleModel: (status: boolean) => void;
  message: string;
}) => {
  const classes = useStyles();
  const { show, handleModel } = props;
  const themeClass = useThemeClassName();
  const { language: lang, rtl } = useAppContext((state) => state);
  const CancelBtn = registry.getSvg("CancelBtn");
  return (
    <Modal
      open={show}
      dir={rtl ? "rtl" : "ltr"}
      style={{ zIndex: 99999 }}
      className={`${classes.Modal}`}
      onClose={() => {
        handleModel(false);
      }}
    >
      <div className={classes.ModalPaper}>
        <div className={classes.Header}>
          <div className={classes.HeaderLeft}>
            <div role="button" tabIndex={0} className={classes.IconContainer}>
              <KnobIcon
                style={{
                  width: "1.333em",
                  transform: "scale(1.5)",
                  height: "1.666em",
                  left: `${rtl ? "calc(20% - 50%)" : "calc(80% - 50%)"}`,
                }}
                className={classes.Icon}
              />
            </div>
            <div className={classes.Title}>{t("Rejection Message")}</div>
          </div>
          <div className={classes.HeaderRight}>
            <CancelBtn
              className={classes.IconClose}
              onClick={() => handleModel(false)}
            />
          </div>
        </div>
        <p id="server-modal-description" className={classes.message}>
          {t(props.message || "-")}
        </p>
      </div>
    </Modal>
  );
};
export default ShowRejectMessage;
